module.exports = __webpack_public_path__ + "27de61f9afcc9aee729f3b8cffb97e01.png";